<template>
  <div :class="readingStyle">
    <div class="article-content allow-select" v-html="caseTitle"></div>

    <annot8-article
      ref="annot8"
      docType="case"
      :doc-id="id"
      :content="content"
    ></annot8-article>

    <div v-if="popupContent">
      <div id="popupMenu" style="display: none">
        <popup-menu ref="popupmenu" :docId="id" docType="case"></popup-menu>
      </div>
      <div id="popupAdd" style="display: none">
        <popup-add :docs="docs" docType="case"></popup-add>
      </div>
    </div>
    <help v-if="popupContent" id="popupHelp" style="display: none" />
  </div>
</template>
<script>
import Annot8Article from "@/components/annot8/Annot8Article";
import Menu from "./PopupMenu";
import Add from "@/views/notebooks/PopupAddToNotebook.vue";
import Help from "@/components/Help.vue";

let alertTimeout;

export default {
  data() {
    return {
      id: null,
      title: "",
      shortTitle: "",
      content: "",
      ponente: "",
      enbanc: false,
      popupContent: true,
      docTitle: "",
      showFull: false,
      digested: false,
      opinions: false,
    };
  },

  computed: {
    docs() {
      return [{ docid: this.id, shortTitle: this.shortTitle }];
    },

    readingStyle() {
      return [
        "reading-" +
          (this.$store.state.settings.settings.readingMode || "normal"),
        "textsize-" +
          (this.$store.state.settings.settings.textSize || "normal"),
      ];
    },

    caseTitle() {
      if (!this.showFull) {
        const regexp = /(<h3>)(.*?)(<\/h3>)/is;
        const temp = this.docTitle.match(regexp);
        if (temp) {
          const matches = temp[0].replace(/.*?[^\s]+(<BR>|<br \/>)/gim, "");
          return this.docTitle.replace(
            regexp,
            `<h3>${
              this.shortTitle
            } <a onclick="showFullTitle(event)" href="#" class="case-more-title">+</a>${
              /^<BR|<br/.test(matches) ? "<br />" : "<br/><br/>"
            }${matches}`
          );
        }
      }

      return this.docTitle;
    },
  },

  methods: {
    async load(id, opinions = false) {
      if (id.startsWith("c")) {
        id = parseInt(id.substring(1), 16);
      }

      this.id = parseInt(id);

      var doc = {};

      const cases = this.$store.state.history.recent.cases || [];

      const caseIdx = cases.findIndex((c) => c.id === id);

      if (caseIdx >= 0 && !opinions) {
        doc = { data: cases[caseIdx] };
      } else {
        doc = await this.$lawyerly.cases.view({ id: id }, opinions);
      }

      // console.log(doc);

      this.title = doc.data.title;
      this.shortTitle = doc.data.shortTitle;
      this.digested = doc.data.digested;

      let content = doc.data.content;

      // optimized cleanup
      content = content.replace(/(<style)(.*?)\>(.*?)(<\/style>)/is, "");
      content = content.replace(/(<script)(.*?)\>(.*?)(<\/script>)/is, "");

      //get title
      const m = content.match(/.*?<\/center>/is);
      //console.log(m[0]);
      if (m.length > 0) {
        this.docTitle = m[0];
      }

      //hide references on print 
      var tdoc = document.createElement('div');
      tdoc.innerHTML = content.replace(/.*?<\/center>/is, "");;

      var sups = tdoc.getElementsByClassName("fn");

      var first = 0;
      for(var i=0; i<sups.length; i++) {
        var item = sups.item(i);
        if (item.innerText.trim() == "[1]") {
          first ++;
        }
        if (first > 1) {
          item.className = "fn no-print";
          // wrap siblings with span
          var next = item.nextSibling;
          while(next && next.className != "fn") {
            if (next.nodeName == "#text") {
              var newSpan = document.createElement('span');
              newSpan.appendChild( document.createTextNode(next.nodeValue));
              next.parentElement.replaceChild(newSpan, next);
              next = newSpan;
            }
            next = next.nextSibling;
          }
        }
      }

      this.content = tdoc.innerHTML;

      this.$store.commit("history/addRecent", {
        data: { ...doc.data, id: id },
        type: "cases",
      });

      if (doc.data.digested == 1) {
        this.$store.commit("ui/setMoreHeaderButtons", this.headerIcons(true));
      } else {
        this.$store.commit("ui/setMoreHeaderButtons", this.headerIcons());
      }

      this.$root.unMountPrintable();
      this.$root.mountPrintable(this.caseTitle, this.content);

      return doc.data.digested == 1;
    },

    more(evt) {
      this.popupContent = false; // re-create always
      setTimeout(() => {
        this.popupContent = true;
        this.$ionic.showPopover(evt, {
          template: "popupMenu",
          translucent: true,
        });
      }, 200);
    },

    addToNotebook(evt) {
      if (!this.$store.getters["user/isAuthenticated"]) {
        this.$router.push("/profile/login");
        return;
      }

      this.popupContent = false; // re-create always
      setTimeout(() => {
        this.popupContent = true;
        this.$ionic.showPopover(null, {
          template: "popupAdd",
          cssClass: "wide-width-popup",
          translucent: true,
        });
      }, 200);
    },

    onHeaderCommand(event, cmd) {
      switch (cmd.cmd) {
        case "more":
          this.more(event);
          break;
        case "add":
          this.addToNotebook();
          break;
        case "share":
          this.share();
          break;
        case "digest":
          this.digest();
          break;
        case "generate":
          this.generate();
          break;
        case "opinions":
          this.showOpinions();
          break;
        case "clear":
          this.clear();
          break;
        case "help":
          this.help();
          break;
      }
    },

    async generate() {
      await this.$ionic.showLoading("Generating digest...");
      alertTimeout = setTimeout(() => {
        this.$router.push("/digests/generated/" + this.id);
        this.$ionic.dismissLoading();
      }, 800);
    },

    async showOpinions() {
      this.opinions = !this.opinions;
      const d = await this.load(
        this.$store.state.route.params.id,
        this.opinions
      );
      this.$store.commit("ui/setMoreHeaderButtons", this.headerIcons(d));
    },

    clear() {
      this.$refs["popupmenu"].clear();
    },

    async digest() {
      await this.$refs["popupmenu"].digest();
    },

    share() {
      this.$refs["popupmenu"].share();
    },
    help() {
      this.popupContent = false;
      setTimeout(() => {
        this.popupContent = true;
        this.$ionic.showPopover(null, {
          template: "popupHelp",
          cssClass: "very-wide-width-popup",
          translucent: true,
        });
      }, 200);
    },

    showFullTitle(e) {
      e.preventDefault();
      this.showFull = true;
      this.$refs["annot8"].onRead();
      this.$root.unMountPrintable();
      this.$root.mountPrintable(this.caseTitle, this.content);
    },

    headerIcons(generated = false) {
      if (generated) {
        return {
          ...this.headerIcons(),
          web: [
            {
              label: "help",
              icon: "help-circle",
              disabled: false,
              emit: "header-command",
              cmd: "help",
            },
            {
              label: "share",
              icon: "share",
              disabled: false,
              emit: "header-command",
              cmd: "share",
            },
            {
              label: this.opinions ? "hide opinions" : "show opinions",
              icon: this.opinions ? "eye-off" : "eye",
              disabled: false,
              emit: "header-command",
              cmd: "opinions",
            },
            {
              label: "digest",
              icon: "list-box",
              disabled: false,
              emit: "header-command",
              cmd: "digest",
            },
            {
              label: "generate",
              icon: "color-wand",
              disabled: false,
              emit: "header-command",
              cmd: "generate",
            },
            {
              label: "add to notebook",
              icon: "custom-si-entypo-book",
              disabled: false,
              emit: "header-command",
              cmd: "add",
            },
          ],
        };
      }
      return {
        mobile: [{ icon: "more", emit: "header-command", cmd: "more" }],
        web: [
          {
            label: "help",
            icon: "help-circle",
            disabled: false,
            emit: "header-command",
            cmd: "help",
          },
          {
            label: "share",
            icon: "share",
            disabled: false,
            emit: "header-command",
            cmd: "share",
          },
          {
            label: this.opinions ? "hide opinions" : "show opinions",
            icon: this.opinions ? "eye-off" : "eye",
            disabled: false,
            emit: "header-command",
            cmd: "opinions",
          },
          {
            label: "digest",
            icon: "list-box",
            disabled: false,
            emit: "header-command",
            cmd: "digest",
          },
          {
            label: "add to notebook",
            icon: "custom-si-entypo-book",
            disabled: false,
            emit: "header-command",
            cmd: "add",
          },
        ],
      };
    },
  },

  mounted() {
    window.showFullTitle = this.showFullTitle;
    this.load(this.$store.state.route.params.id);

    // this.$store.commit("ui/setMoreHeaderButtons", headerIcons);
    this.$root.$on("header-command", this.onHeaderCommand);
    this.$watch(
      () => {
        return this.$refs["annot8"].state.annotations.length;
      },
      () => {
        if (this.$refs["annot8"].state.annotations.length > 0) {
          this.$store.commit("ui/ShowClearHighlights", true);
        } else {
          this.$store.commit("ui/ShowClearHighlights", false);
        }
      }
    );
  },

  beforeDestroy() {
    this.$root.unMountPrintable();
    this.$store.commit("ui/setMoreHeaderButtons", { mobile: [], web: [] });
    this.$root.$off("header-command", this.onHeaderCommand);
    this.$store.commit("ui/ShowClearHighlights", false);
    clearTimeout(alertTimeout);
  },

  components: {
    "annot8-article": Annot8Article,
    "popup-menu": Menu,
    "popup-add": Add,
    help: Help,
  },
};
</script>
<style>
.case-more-title {
  font-size: 1.3em;
  text-decoration: none;
}
.case-more-title:hover {
  text-decoration: underline;
}
</style>
